import $ from 'jquery';
import Backbone from 'backbone';
import template from '../templates/modal.html';

const doNotShowItAgainLabels = {
  es: 'No mostrar este mensaje de nuevo',
  en: 'Do not show this message again',
  it: 'Non mostrare più questo messaggio',
  pt: 'Não mostrar esta mensagem novamente',
  fr: 'Ne plus afficher ce message',
};
const closeWithButtonLabel = {
  es: 'Aceptar',
  en: 'Accept',
  it: 'Accettare',
  pt: 'Aceitar',
  fr: 'Accepter',
};

const NoticesModalView = Backbone.View.extend({
  events: {
    'click #noticeModal .close': 'closeAction',
    'click #closeWithButton .close': 'closeAction',
  },
  initialize(options) {
    this.options = options || {};
  },
  render() {
    const { noticeData } = this.options;

    if (noticeData) {
      noticeData.showItAgainLabel = doNotShowItAgainLabels[noticeData.lang];
      noticeData.closeWithButtonLabel = noticeData.button
        ? noticeData.button
        : closeWithButtonLabel[noticeData.lang];

      this.$el.append(template(noticeData));
      $('#noticeModal').show();
    }
  },
  close() {
    $('#noticeModal').hide();
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    this.$el.empty().off();
  },
  closeAction(event) {
    event.preventDefault();
    let deleteNotice = $('#showNoticeAgain').is(':checked');
    this.close();
    if (event.target.id === 'closeWithButton') {
      deleteNotice = true;
    }

    if (this.options.closeCallback) {
      let callback = null;
      if (event.target.id === 'closeWithButton' && this.options.noticeData.urlToClose) {
        callback = () => {
          // eslint-disable-next-line no-undef
          const bytes = new TextEncoder().encode(window.location);
          const redirectBase64 = bytes.toBase64();

          // eslint-disable-next-line no-undef
          window.location = `${this.options.noticeData.urlToClose}/${redirectBase64}`;
        };
      }
      this.options.closeCallback({
        noticeData: this.options.noticeData,
        delete: deleteNotice,
        callback,
      });
    }
  },
});

export default NoticesModalView;



/** WEBPACK FOOTER **
 ** ./src/views/modal.js
 **/